export const getTokenAuthStorage = () => {
  try {
    const auth = atob(localStorage.getItem('ECCO_IND_AUTH'));
    return JSON.parse(auth);
  } catch (e) {
    return null;
  }
};

/** Token de sesión del flujo de contratación (inicio_tramite / auth-login). */
export const hasHireAuthToken = () => Boolean(getTokenAuthStorage()?.token);